// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Slovenia */
const SI =
  /^(?:65(?:[178]\d|5[56]|6[01])\d{4}|(?:[37][01]|4[013]|51|6[489])\d{6})$/;

export default SI;
